module.exports = __webpack_public_path__ + "assets/orange-sm-logo-e379b0.svg";